import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { UseProjectsListBaseData, UseProjectsListProps } from ".";

export function useProjectsList<TData = UseProjectsListBaseData>({ orgId, sortByCreatedAtAscending = false, select }: UseProjectsListProps<TData>) {
    return useQuery({
        ...queryKeys.project.list._ctx.byOrgId({ orgId: orgId!, sortByCreatedAtAscending }),
        enabled: !!orgId,
        select,
    });
}